export default __webpack_public_path__ + "static/media/physical_digital.1a2b2062.png";